import config from 'helpers/configHelper';
import httpHelper from 'helpers/httpHelper';
import uiHelper from 'helpers/uiHelper';
import Cookies from 'js-cookie';
import {isEmpty} from 'lodash';

const ERROR_MESSAGE = 'An error occurred';

export default {
  signUp,
  login,
  passwordForgot,
  resetPasswordTokenCheck,
  resetPassword,
  activateAccount,
  resendConfirmationEmail,
  getToken,
  saveToken,
  getApiToken,
  saveApiToken
};

async function signUp(user) {
  try {
    let response = await httpHelper.post('/signup', user, {notVersioned: true, acceptableErrorCodes: [500]});

    if (response || isEmpty(response)) return {success: true};

    return undefined;
  } catch (err) {
    let errMessage = httpHelper.getErrorMessage(err);
    if (errMessage && config.isDevLocal) console.log(errMessage);

    uiHelper.showError(ERROR_MESSAGE);

    return undefined;
  }
}

function login(user) {
  return httpHelper.post('/login', user, {notVersioned: true, acceptableErrorCodes: [401]});
}

async function passwordForgot(email: string) {
  try {
    let response = await httpHelper.post('/reset', {Email: email}, {notVersioned: true, acceptableErrorCodes: [500]});

    if (response || isEmpty(response)) return {success: true};

    return undefined;
  } catch (err) {
    let errMessage = httpHelper.getErrorMessage(err);
    if (errMessage && config.isDevLocal) console.log(errMessage);

    uiHelper.showError(ERROR_MESSAGE);

    return undefined;
  }
}

function resetPasswordTokenCheck(token: string) {
  return httpHelper.get(`/reset/${token}`, {}, {notVersioned: true});
}

function resetPassword(userData) {
  let data = {
    Token: userData.token,
    NewPassword: userData.password,
    NewPasswordConfirm: userData.confirmPassword
  };

  return httpHelper.post('/reset/complete', data, {notVersioned: true});
}

async function activateAccount(token: string) {
  try {
    let response = await httpHelper.get(`/confirm/${token}`, {}, {notVersioned: true, acceptableErrorCodes: [500]});

    if (response || isEmpty(response)) return {success: true};

    return undefined;
  } catch (err) {
    let errMessage = httpHelper.getErrorMessage(err);
    if (errMessage && config.isDevLocal) console.log(errMessage);

    uiHelper.showError(ERROR_MESSAGE);

    return undefined;
  }
}

async function resendConfirmationEmail() {
  try {
    let response = await httpHelper.post('/resend', {}, {notVersioned: true, acceptableErrorCodes: [500]});

    if (response || isEmpty(response)) return {success: true};

    return undefined;
  } catch (err) {
    let errMessage = httpHelper.getErrorMessage(err);
    if (errMessage && config.isDevLocal) console.log(errMessage);

    uiHelper.showError(ERROR_MESSAGE);

    return undefined;
  }
}

function getToken() {
  let token = Cookies.get('jwt_token');
  return token;
}

function saveToken(jwt) {
  Cookies.set('jwt_token', jwt);
}

function getApiToken() {
  let apiToken = Cookies.get('api_token');
  return apiToken;
}

function saveApiToken(token) {
  Cookies.set('api_token', token);
}
